import { Customization, EquipmentConfiguration } from '@/common/types/student';
import Customizations from '@/game/GameComponents/GameData/customizationsNPC.json';
import _ from 'lodash';
import pi from './Pi.json';

export enum NpcGender {
  MALE = 'm',
  FEMALE = 'f',
}

export function createNPCOutfit(
  studentId: string,
  level: number,
  npcId: number,
): Partial<EquipmentConfiguration> {
  const hash = getNPCHash(studentId, level, npcId);
  const npcGender = getGenderFromHash(hash);

  const complexion = getComplexionFromHash(hash);
  const hair = getHairFromHash(hash, npcGender);
  const clothes = getClothesFromHash(hash, npcGender);
  const pants = getPantsFromHash(hash, npcGender);
  const shoes = getShoesFromHash(hash, npcGender);

  const config = { complexion, hair, clothes, pants, shoes };
  // console.log('created outfit for NPC:', {
  //   id: npcId,
  //   level: level,
  //   hash: hash,
  //   config: config,
  // })

  return config;
}

export function getRandomComplexion() {
  const allComplexions = Customizations.filter(
    (c) => c.slot === 'complexion',
  ) as Customization[];
  return _.sample(allComplexions);
}

export function getRandomHair() {
  const allHairs = Customizations.filter(
    (c) => c.slot === 'hair',
  ) as Customization[];
  return _.sample(allHairs);
}

export function getRandomClothes() {
  const allClothes = Customizations.filter(
    (c) => c.slot === 'clothes',
  ) as Customization[];
  return _.sample(allClothes);
}

export function getRandomPants() {
  const allPants = Customizations.filter(
    (c) => c.slot === 'pants',
  ) as Customization[];
  return _.sample(allPants);
}

export function getRandomShoes() {
  const allShoes = Customizations.filter(
    (c) => c.slot === 'shoes',
  ) as Customization[];
  return _.sample(allShoes);
}

function getCosmeticFromHash(
  hash: string,
  slot: string,
  npcGender?: NpcGender,
) {
  let availableCustomizations = Customizations.filter(
    (c) => c.slot === slot && !c.disable,
  ) as Customization[];

  // Optionally filter by gender.
  if (npcGender) {
    availableCustomizations = availableCustomizations.filter(
      (c) => !c.gender || c.gender === npcGender,
    );
  }

  const cosmeticIndex = parseInt(hash) % availableCustomizations.length;
  return availableCustomizations[cosmeticIndex].id;
}

function getComplexionFromHash(hash: string) {
  const complexionDigits = hash.substring(0, 2);
  return getCosmeticFromHash(complexionDigits, 'complexion');
}

function getClothesFromHash(hash: string, npcGender?: NpcGender) {
  const clothesDigits = hash.substring(2, 5);
  return getCosmeticFromHash(clothesDigits, 'clothes', npcGender);
}

function getPantsFromHash(hash: string, npcGender?: NpcGender) {
  const pantsDigits = hash.substring(5, 8);
  return getCosmeticFromHash(pantsDigits, 'pants', npcGender);
}

function getShoesFromHash(hash: string, npcGender?: NpcGender) {
  const shoesDigits = hash.substring(8, 11);
  return getCosmeticFromHash(shoesDigits, 'shoes', npcGender);
}

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getHatsFromHash(hash: string) {
  const hatsDigits = hash.substring(11, 14);
  return getCosmeticFromHash(hatsDigits, 'hats');
}

function getHairFromHash(hash: string, npcGender?: NpcGender) {
  const hairDigits = hash.substring(14, 17);
  return getCosmeticFromHash(hairDigits, 'hair', npcGender);
}

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getFaceFromHash(hash: string) {
  const faceDigits = hash.substring(17, 20);
  return getCosmeticFromHash(faceDigits, 'face');
}

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getBackFromHash(hash: string) {
  const backDigits = hash.substring(20, 23);
  return getCosmeticFromHash(backDigits, 'back');
}

// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getGlovesFromHash(hash: string) {
  const glovesDigits = hash.substring(23, 26);
  return getCosmeticFromHash(glovesDigits, 'gloves');
}

function getGenderFromHash(hash: string) {
  const genderDigits = hash.substring(26, 27);
  const index = parseInt(genderDigits) % 2;
  return [NpcGender.MALE, NpcGender.FEMALE][index];
}

export function getNPCHash(studentId: string, level: number, npcId: number) {
  const input = `${studentId}-${level}-${npcId}`;
  const piString = pi['pi'].toString();
  const numDigits = 28;
  const seed = 526472742;
  let sumOfCharCodes = 0;
  for (var n = 0; n < input.length; n++) {
    sumOfCharCodes += input.charCodeAt(n);
  }
  let hash = seed;
  let output = '';
  for (let i = 0; i < numDigits; i++) {
    hash =
      (hash * seed * input.charCodeAt(i % input.length) + sumOfCharCodes) %
      piString.length;
    const newDigit = piString[hash];
    output += newDigit;
  }

  return output;
}

export function performSlotHiding(
  parent: Phaser.GameObjects.Container,
  equippedItems: Partial<EquipmentConfiguration>,
  prefix: string = '',
  customizations: Customization[] = [],
) {
  Object.keys(equippedItems).forEach((key: string) => {
    const customizationId = equippedItems[key as keyof EquipmentConfiguration];
    const customizationData = customizations.find(
      (customization) => customization.id === customizationId,
    ) as Customization;
    if (customizationData) {
      if (customizationData.hidesSlots) {
        customizationData.hidesSlots.forEach((d: any) => {
          const slotObj = parent.list.find(
            (child) => child.name === `${prefix}${d}`,
          );
          (slotObj as Phaser.GameObjects.Sprite).setVisible(false);
        });
      }
    }
  });
}
